module.exports = __webpack_public_path__ + "static/img/icon_vip2.ffcf7d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_vip2.png
// module id = +FKa
// module chunks = 192